/* eslint-disable  id-length */

import { Vector } from "./Vector";

export class Path {
  commands: string[];

  constructor(commands: string[]) {
    this.commands = commands;
  }

  static M(point: Vector): string {
    return `M${point.x} ${point.y}`;
  }

  static Q(control: Vector, to: Vector): string {
    return `Q${control.x} ${control.y} ${to.x} ${to.y}`;
  }

  static L(point: Vector): string {
    return `L${point.x} ${point.y}`;
  }

  static Z(): string {
    return "Z";
  }

  toString(): string {
    return this.commands.join("");
  }
}
